import { render } from "./DownloadedSnack.vue?vue&type=template&id=52a4de35"
import script from "./DownloadedSnack.vue?vue&type=script&lang=js"
export * from "./DownloadedSnack.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__